/**
 * What a person is coming to therapy for, as opposed to how a therapist works.
 *
 * Kept apart from THERAPY_TYPES on purpose: a therapist knows they practise
 * EMDR, someone looking for help knows they cannot sleep. This is the
 * vocabulary a visitor arrives with.
 *
 * Values MUST stay in sync with the backend enum `PresentingProblem` in
 * backend/app/domain/models/therapy_tool.py.
 */
export const PRESENTING_PROBLEMS = [
    "anxiety",
    "panic",
    "depression",
    "stressBurnout",
    "sleep",
    "grief",
    "trauma",
    "selfEsteem",
    "couple",
    "family",
    "sexuality",
    "eating",
    "addiction",
    "ocd",
    "phobia",
    "adhd",
    "autism",
    "childAdolescent",
    "perinatal",
    "chronicIllness",
    "workCareer",
    "lifeTransition",
    "loneliness",
    "anger",
    "genderIdentity",
    "bipolar",
    "psychosis",
    "personality",
    "bodyAwareness",
] as const;

export type PresentingProblem = (typeof PRESENTING_PROBLEMS)[number];
